export const DEFAULT_SETTINGS = {
  moodCheckins: { enabled: true, times: ['09:00', '15:00', '21:00'] },
  meditation: { enabled: false, time: '07:00' },
  habits: { enabled: true, time: '20:00' },
  safetyPlan: { enabled: true, frequency: 'weekly' },
  emergencyContact: { enabled: false, frequency: 'weekly' },
  quietHours: { enabled: true, start: '22:00', end: '07:00' },
  priorityOverride: true,
};

